import { useQuery } from '@tanstack/react-query';
import { apiRoutes } from '../../../constants/apiRoutes';
import { getAxios } from '../../../util/axios';
import { SelectOption } from '@cksoftware/react-base';

export function useAuctioneerListQuery(enabled: boolean) {
  const url = apiRoutes.auctioneer.list;
  return useQuery({
    queryKey: [url],
    enabled: enabled,
    queryFn: async () => {
      const query = await getAxios().get<SelectOption[]>(url);
      return query.data;
    }
  });
}
